import React, { useEffect, useState } from 'react'
import { getImages } from '../const';

const ChatGroupList = ({chatList, setNewGroup, groupName, setGroupName, setGroupChatName, createChat}) => {

    const [searchTerm, setSearchTerm] = useState('');
    const [selectedUsers,setSelectedUsers] = useState([]);

    const handleSearchChange = (event) => {
        setSearchTerm(event.target.value);
    };

    const filteredChatList = chatList.filter((item) =>
        item.name.toLowerCase().includes(searchTerm.toLowerCase())
    );

    const addGroupChatUser = (user,index) => {
        console.log(user);

        if(selectedUsers.includes(index)) setSelectedUsers(selectedUsers.filter((i) => i != index));
        else setSelectedUsers([...selectedUsers,index]);
    }

    const createGroup = () => {
        console.log(groupName);
        console.log(selectedUsers);

        if(groupName == "") {
            alert("Please enter a group name");
            return;
        }

        if(selectedUsers.length == 0) {
            alert("Please select at least one recipient");
            return;
        }

        createChat({name:groupName,participants:chatList.filter((v,i) => selectedUsers.includes(i))});

        setNewGroup(false);
    }


  return (
    <>
        <div className="chatlist p-0">
            <div className="msg-head d-flex align-items-center justify-content-between d-md-none group-mob-header">
                <button className='white-back-arrow cursor-pointer d-md-none' onClick={() => {setNewGroup(false);}}>
                    <img src={getImages('back-arrow.svg')} />
                </button>
                <div className='d-flex align-items-center w-100'>
                    <div className='chat-sm-title text-white fw-500 me-3'>Add Group Participants</div>
                </div>
            </div>
            <div className="chat-header d-none d-md-block">
                <div className='d-flex align-items-center justify-content-between mb-4'>
                    <span className='ch-xs-title' onClick={() => {setNewGroup(false);}}><span className='chat-back-arrow me-2'></span>Add Group Participants</span>
                    <div className='member-count'>3 of 10</div>
                </div>
                <div className="msg-search w-100 ">
                    <div className='position-relative search-input'>
                        <input type="text" 
                            className="form-control"
                            placeholder="Search" 
                            value={searchTerm}
                            onChange={handleSearchChange} 
                        />
                        <span className="gray-search-icon"></span>
                    </div>
                </div>
            </div>
            <div className="modal-dialog-scrollable">
                <div className="modal-content">
                    <div className="modal-body p-0">
                        <div className="chat-lists">
                            <div className="chat-list chat-group-list">
                                {filteredChatList.map((user, index) => (
                                    <div key={index}>
                                        <button type="button" className={`d-flex align-items-center w-100 ${(selectedUsers.includes(index)) ? "checked" : ""}`} onClick={(e) => {e.preventDefault(); addGroupChatUser(user,index)}}>
                                            <div className="flex-shrink-0">
                                                <span className='user-icon'><img src={getImages('icon-chat-user.svg')} alt="user" /></span>
                                            </div>
                                            <div className="flex-grow-1 ms-3">
                                                <h3>{user.name} <span className="status-circle green"></span></h3>
                                                <p>{user.company}</p>
                                            </div>
                                            <div className='flex-grow-1 text-end'>
                                                <div className="custom-checkbox sm-checkbox group-chat-checkbox">
                                                    <input className="styled-checkbox" type="checkbox" id={`groupMember_${index}`} checked={selectedUsers.includes(index)} value={index} onClick={(e) => {e.preventDefault();}} onChange={(e) => {e.preventDefault();}}/>
                                                    <label htmlFor={`groupMember_${index}`}><span></span></label>
                                                </div>
                                            </div>
                                        </button>
                                    </div>
                                ))}
                            </div>
                            <div className='ps-4 pt-5 pe-4'>
                                <div className='chat-ssm-title text-start mb-5'>You can select up to <span>10</span> participants</div>
                                <div className='custom-form chat-custom-form'>
                                    <div className='form-group mb-30'>
                                        <label>Group Name</label>
                                        <input type='text'
                                            className='form-control'
                                            value={groupName}
                                        onChange={(e)=>setGroupName(e.target.value)}
                                        onKeyPress={(e) => {if (e.key === 'Enter') {setGroupChatName()}}}
                                            placeholder='Enter group name' />
                                    </div>
                                    <button type="button" onClick={createGroup} className='red-btn w-100 ms-0 text-uppercase'>Create Group</button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </>
  )
}

export default ChatGroupList